import React from "react";
import GreenArrow from "../assets/imgTwo/bigArrow.svg";
import celebrate from "../assets/imgTwo/celebrate.svg";
import guy from "../assets/imgTwo/guyGallery.svg";
import girl from "../assets/imgTwo/girlCoffee.svg";
import laptop from "../assets/imgTwo/girlLaptop.svg";
import team from "../assets/imgTwo/team.svg";
// import oops from "../assets/imgTwo/oops.svg";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const GallerySection = () => {
  return (
    <section
      id="about"
      className=" py-16 animate-slidein"
    >
      <h2 className="text-2xl md:text-[3.5rem] font-bold mb-4 leading-normal text-white text-center my-12">
        Ready to kickstart your journey <br></br>
        with Uniswitch?<br></br>
        <span className="text-[#07775D]">Come join us.</span>
      </h2>



      <div className="w-full max-w-screen-xl mx-auto pt-12 px-4 overflow-scroll">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 h-screen">
          <div className="md:col-span-1">
            <img
              src={guy}
              alt="Small 3"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>

          <div className="flex flex-col gap-4">
            <img
              src={laptop}
              alt="Small 1"
              className="w-full h-[30%] object-cover rounded-lg"
            />
            <img
              src={girl}
              alt="Small 2"
              className="w-full h-[70%] object-cover rounded-lg"
            />
          </div>


          <div className="md:col-span-2 flex flex-col gap-4">
            <img
              src={team}
              alt="Big 1"
              className="w-full h-[70%] object-cover rounded-lg"
            />
            <img
              src={celebrate}
              alt="Big 2"
              className="w-full h-[30%] object-cover rounded-lg"
            />
          </div>
        </div>
      </div>

    </section>
  );
};

export function NoOpenRoles() {
  return (
    <div className=" flex flex-col items-center justify-start p-8 space-y-12">

      <div className="w-full max-w-4xl flex flex-col md:flex-row items-center justify-center gap-6">
        <input
          type="text"
          placeholder="Search role"
          className="border border-green-400 rounded-md p-3 w-full md:w-1/3 focus:outline-none"
        />
        <select className="border border-green-400 rounded-md p-3 w-full md:w-1/3 focus:outline-none">
          <option>All teams</option>
        </select>
        <select className="border border-green-400 rounded-md p-3 w-full md:w-1/3 focus:outline-none">
          <option>All location</option>
        </select>
      </div>

      <div className="flex flex-col items-center">

        <p className="mt-6 text-center text-xl italic">
          No open roles at the moment <br /> check back soon!
        </p>
      </div>
    </div>
  );
}


export const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
    >
      <h2 className="text-2xl text-center md:text-[2.5rem] font-bold mb-4 leading-normal">
        View Open Roles
      </h2>
      <div className="flex justify-center items-center">
        <img
          src={GreenArrow}
          alt="unlock possibilities"
        />
      </div>

      <NoOpenRoles />

    </section>
  );
};




export const Career = () => (
  <div className="font-san mx-auto bg-[#000000] pt-6">
    <Navbar />
    <GallerySection />
    <HeroSection />
    <Footer />
  </div>
);

export default Career;
